export const SITE = {
  name: "Vivek Chandra",
  role: "Software Engineer • AI Builder • Technical Consultant",
  domain: "vivekchandra.dev",
  email: "vivek1389@gmail.com",
  linkedin: "https://www.linkedin.com/in/vivek-chandra-b100424b/",
  github: "https://github.com/vivek1389",
  company: "TrueQual Dataworks",
  companyUrl: "https://truequaldataworks.com",
  portrait: "/vivek-headshot.jpg",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "Product Engineering",
  "AI Systems",
  "Enterprise Software",
  "Web Applications",
  "Technical Strategy",
  "Engineering Leadership",
  "Software Architecture",
  "Delivery Analytics",
];

export const EXPERIENCE_CARDS = [
  {
    stat: "15+",
    title: "Years in Engineering",
    body: "Production software engineering across enterprise systems, modern web applications and AI-powered products.",
  },
  {
    stat: "Adobe",
    title: "Enterprise at Scale",
    body: "More than a decade building enterprise software used by millions of users, collaborating across engineering, research, product management and design.",
  },
  {
    stat: "Enterprise",
    title: "Built to Last",
    body: "Designed systems where correctness, maintainability, quality and long-term reliability were critical.",
  },
  {
    stat: "AI",
    title: "Applied to Real Problems",
    body: "Worked on AI-powered products and intelligent workflows, focused on practical business applications rather than technology for its own sake.",
  },
  {
    stat: "Lead",
    title: "Technical Leadership",
    body: "Led engineering initiatives, mentored teams, raised software quality and collaborated across organizations and disciplines.",
  },
  {
    stat: "Founder",
    title: "TrueQual Dataworks",
    body: "Founded TrueQual Dataworks and built digital products for businesses, combining engineering expertise with an understanding of real business challenges.",
  },
];

export const WHY_CLIENTS = [
  {
    index: "01",
    title: "Enterprise Experience",
    body: "More than fifteen years building software has taught me how to design systems that stay reliable, maintainable and scalable as your business grows.",
  },
  {
    index: "02",
    title: "Business Perspective",
    body: "As both an engineer and a business owner, I know that software is only valuable when it solves real operational and commercial problems.",
  },
  {
    index: "03",
    title: "Practical AI",
    body: "I build AI features where they create measurable value, improving workflows, productivity and customer experience instead of adding unnecessary complexity.",
  },
];

export const SERVICES = [
  {
    slug: "custom-business-websites",
    index: "01",
    title: "Custom Business Websites",
    outcome: "Build credibility, earn trust and turn visitors into customers.",
    body: "Modern, high-performance websites that load fast, rank well and represent your business the way it deserves. Designed to turn attention into enquiries and enquiries into revenue.",
    points: [
      "Conversion-focused design",
      "Fast and SEO-ready",
      "Clear brand positioning",
    ],
  },
  {
    slug: "modern-web-applications",
    index: "02",
    title: "Modern Web Applications",
    outcome: "Run your business on software built around how you actually work.",
    body: "Custom business software, customer portals, SaaS products and internal systems designed around your workflows, instead of forcing your team to adapt to generic tools.",
    points: [
      "SaaS and customer portals",
      "Dashboards and internal tools",
      "Workflow automation",
    ],
  },
  {
    slug: "ai-powered-solutions",
    index: "03",
    title: "AI-powered Solutions",
    outcome: "Apply AI only where it creates measurable business value.",
    body: "Practical AI that improves how your business runs, through automation, document intelligence, intelligent search and workflow optimisation, without adding complexity you do not need.",
    points: [
      "Automation and assistants",
      "Document intelligence",
      "Intelligent search",
    ],
  },
  {
    slug: "technical-consulting",
    index: "04",
    title: "Technical Consulting",
    outcome: "Bring an experienced engineering partner into the room.",
    body: "Support with architecture, product strategy, technical planning and the complex engineering decisions that are expensive to get wrong. Clear, honest guidance from someone who has built and shipped real software.",
    points: [
      "Architecture and strategy",
      "Product and technical planning",
      "Engineering leadership",
    ],
  },
];
